import axios, {AxiosPromise, AxiosRequestConfig} from 'axios'

// https://github.com/axios/axios
const $http = axios.create({
  timeout: 70 * 1000, // 70 sec max
})

$http.defaults.xsrfHeaderName = 'X-CSRFToken'
$http.defaults.xsrfCookieName = 'csrftoken'
$http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export default {
  spaces: {
    activity(spaceIds: string[]) {
      return $http.get(`/api/spaces/activity?space_ids=${spaceIds.join(',')}`)
    },
    getVoiceToken(spaceId: string) {
      return $http.get(`/api/spaces/${spaceId}/voice-token`)
    },
    chartRoomActivity(spaceId: string, params: any) {
      return $http.get(`/api/spaces/${spaceId}/chart/room-activity`, {
        params,
      })
    },
    chartRoomActivityGrouping(spaceId: string, params: any) {
      return $http.get(`/api/spaces/${spaceId}/chart/room-activity-grouping`, {
        params,
      })
    },
    chartRoomMotionTrend(spaceId: string, params: any) {
      return $http.get(`/api/spaces/${spaceId}/chart/motion-trend`, {
        params,
      })
    },
    chartSensoryData(spaceId: string, params: any) {
      return $http.get(`/api/spaces/${spaceId}/chart/sensory-data`, {
        params,
      })
    },
  },
}
